module.exports = __webpack_public_path__ + "assets/images/5-37Le_Vt.jpg";